import type { KkmServerCommandStatus } from '@/shared/api';

import { OrderFiscalKkmCommandStatus } from '@shared/api/graphql/gql/graphql';

/**
 * Числовой статус ответа KKMServer в enum контракта backend. Таблица закрыта по
 * `KkmServerCommandStatus`: новый статус протокола ломает компиляцию здесь, а не
 * молча уезжает в `Error` у одного из потребителей.
 */
const GRAPHQL_COMMAND_STATUSES: Record<KkmServerCommandStatus, OrderFiscalKkmCommandStatus> = {
  0: OrderFiscalKkmCommandStatus.Ok,
  1: OrderFiscalKkmCommandStatus.Run,
  2: OrderFiscalKkmCommandStatus.Error,
  3: OrderFiscalKkmCommandStatus.NotFound,
  4: OrderFiscalKkmCommandStatus.NotRun,
  5: OrderFiscalKkmCommandStatus.AlreadyDone,
};

export function graphqlKkmCommandStatus(status: KkmServerCommandStatus | null): OrderFiscalKkmCommandStatus | null {
  return status === null ? null : GRAPHQL_COMMAND_STATUSES[status];
}
